module.exports = __webpack_public_path__ + "static/media/4_armies.5aea8e6d.png";